export default "__VITE_ASSET__C1fm9mZl__"